import { render, staticRenderFns } from "./TopLocationProjectPageBanner.vue?vue&type=template&id=57547c94&scoped=true&"
import script from "./TopLocationProjectPageBanner.vue?vue&type=script&lang=js&"
export * from "./TopLocationProjectPageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57547c94",
  null
  
)

export default component.exports